export default __webpack_public_path__ + "static/12_34-9e5ccb9af83fd5956ddf0c2cd94c96bb.png";